import { ActionType } from "@sp-crm/core";
import { Feature } from "components/feature";
import * as React from "react";
import { Redirect, useParams } from "react-router-dom";
import {
    useCrmMode,
    useFranchiseManagementEnabled,
    useIsAllowed,
} from "store/selectors/hooks";
import { ActivitiesReport } from "./activities-report/activities-report-page";
import { CommissionReport } from "./commission-report";
import { CustomReports } from "./custom-reports";
import { FranchiseRoyalties } from "./franchise-royalties";
import { MarketerGoals } from "./marketer-goals";
import { OutstandingInvoices } from "./outstanding-invoices";
import { ReferralSource } from "./referral-source";
import { ClientPlacementRevenue } from "./revenue";
import { StageConversion } from "./stage-conversion";
import { Summary } from "./summary";
import { TimeInStage } from "./time-in-stage";
import { TimeTracking } from "./time-tracking";

export const ReportsShow: React.FC = () => {
    const params = useParams<{ reportname?: string }>();
    const reportName = params.reportname || "summary";
    const canViewReports = useIsAllowed(ActionType.ViewReports);
    const { placementEnabled, homeCareEnabled } = useCrmMode();
    const franchiseManagementEnabled = useFranchiseManagementEnabled();

    if (reportName === "custom") {
        return <CustomReports />;
    }

    if (!canViewReports) {
        return <Redirect to="/reports/show/custom" />;
    }

    if (reportName === "summary") {
        return (
            <Feature name="placement">
                <Summary />
            </Feature>
        );
    }

    if (reportName === "revenue") {
        return (
            <Feature name="placement">
                <ClientPlacementRevenue />
            </Feature>
        );
    }

    if (reportName === "inbound-referrals" || reportName === "referrals") {
        return <Redirect to="/reports/show/referral-source" />;
    }

    if (reportName === "marketer-goals") {
        return (
            <Feature name="marketingGoals">
                <MarketerGoals />
            </Feature>
        );
    }

    if (reportName === "activities") {
        return (
            <Feature name="activitiesReport">
                <ActivitiesReport />
            </Feature>
        );
    }

    if (reportName === "referral-source") {
        if (!placementEnabled && !homeCareEnabled) {
            return <h2>Sorry, no report found</h2>;
        }
        return <ReferralSource />;
    }

    if (reportName === "stage-conversion") {
        return (
            <Feature name="placement">
                <StageConversion />
            </Feature>
        );
    }

    if (reportName === "time-in-stage") {
        return (
            <Feature name="placement">
                <Feature name="timeInStageReport">
                    <TimeInStage />
                </Feature>
            </Feature>
        );
    }

    if (reportName === "franchise-royalties") {
        if (!franchiseManagementEnabled) {
            return <h2>Sorry, no report found</h2>;
        }
        return <FranchiseRoyalties />;
    }

    if (reportName === "outstanding-invoices") {
        return (
            <Feature name="placement">
                <OutstandingInvoices />
            </Feature>
        );
    }

    if (reportName === "commission-report") {
        return (
            <Feature name="employeeCommissions">
                <CommissionReport />
            </Feature>
        );
    }

    if (reportName === "time-tracking") {
        return (
            <Feature name="trackTime">
                <TimeTracking />
            </Feature>
        );
    }

    return <h2>Sorry, no report found</h2>;
};
